import TableHead from './table-head';

export default TableHead;